import React from 'react'
import { Row } from '@fs/zion-ui'
import mapSvg from '../../../../assets/map.svg'

type PlaceReportsNoRegionSelectedMapProps = Readonly<{
  message: string
}>

export default function PlaceReportsNoRegionSelectedMap({
  message,
}: PlaceReportsNoRegionSelectedMapProps): JSX.Element {
  return (
    <Row>
      <div style={{ position: 'relative', textAlign: 'center' }}>
        <img src={mapSvg} alt="World Map" style={{ width: '100%' }} />
        <div
          style={{
            position: 'absolute',
            top: '50%',
            insetInlineStart: '50%',
            transform: 'translate(-50%, -50%)',
            color: 'white',
            backgroundColor: 'rgba(0, 0, 0, 0.75)',
            padding: '10px',
            borderRadius: '5px',
            fontSize: '2em',
            textShadow: '2px 2px 4px rgba(0, 0, 0, 0.8)',
          }}
        >
          {message}
        </div>
      </div>
    </Row>
  )
}
